
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBuoySparSouth as ObiBuoySparSouthElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-buoy-spar-south.js';
 
 
 

 
 export const ObiBuoySparSouth = createComponent({
   react: React,
   tagName: 'obi-buoy-spar-south',
   elementClass: ObiBuoySparSouthElement,
   events: {
     
   }
  });
 
 